import DateBadges from './DateBadges'

export default DateBadges
